import "./App.css";
import HomeScreen from "./screens/home";

function App() {
  return (
    <div className="App">
      <HomeScreen />
    </div>
  );
}

export default App;
